import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { sidebarActive } from '@Lib/slices/uiSlice';

import { Circle } from 'react-feather';

function MobileMenuItem({ item, handleClickItem }) {
  const routeMatch = useRouteMatch();
  const dispatch = useDispatch();

  const getMenuHref = () => {
    if (!item.path?.includes('hr.vvg.io.vn')) {
      return item.path;
    }

    const base = item.path.replace('/login', '');
    const token = localStorage.getItem(process.env.TOKEN);
    return `${base}/auth/callback?token=${token}&redirect=/dashboard`;
  };

  useEffect(() => {
    if (routeMatch.path === item.path) {
      dispatch(sidebarActive(item.id));
    }
  }, []);

  return (
    <li className={`nav-item ${item.isActive ? 'active' : ''}`}>
      <a
        className="d-flex align-items-center"
        onClick={(e) => {
          if (item.isExternal) return; // Cho phép mở link trực tiếp bằng thẻ a
          e.preventDefault();
          handleClickItem(item);
        }}
        href={getMenuHref()}
        target={item.isExternal ? '_blank' : '_self'}
        rel={item.isExternal ? 'noreferrer' : ''}
      >
        {item.icon ? (
          <span className="mobile-menu-icon-slot d-flex align-items-center justify-content-center">
            {React.isValidElement(item.icon) || typeof item.icon === 'function' ? (
              item.icon
            ) : (
              <span dangerouslySetInnerHTML={{ __html: item.icon }} />
            )}
          </span>
        ) : (
          <Circle size={12} />
        )}
        <span
          className="menu-title mobile-menu-title text-truncate"
          style={{ position: 'relative' }}
        >
          {item.name}
          {item.badge && (
            <span
              className="badge badge-pill badge-light-danger"
              style={{
                position: 'absolute',
                top: '-5px',
                right: '-15px',
                fontSize: '7px',
                padding: '1px 3px',
                lineHeight: '1',
              }}
            >
              {item.badge}
            </span>
          )}
        </span>
      </a>
    </li>
  );
}

MobileMenuItem.propTypes = {
  item: PropTypes.object,
  handleClickItem: PropTypes.func,
};

export default MobileMenuItem;
